export const formatLogonId = (logonId: string) => logonId;
